<template>
  <div class="canvas-container">
    <canvas :id="id" style="width:900px; height: 130px" class="canvas-box"> </canvas>
    <div class="canvas-tooltip" v-if="target" :style="{top:`${target.y}px`, left: `${target.x}px`}">
      <ul>
        <li><label>测试时间</label><span>{{ target.p.dt }}</span></li>
        <li><label>测试版本</label><span>{{ target.p.version }}</span></li>
        <li><label>样本量</label><span>{{ target.p.cnt }}</span></li>
        <li><label>得分</label><span>{{ target.p.score%1===0?target.p.score:target.p.score.toFixed(1) }}</span></li>
      </ul>
    </div>
  </div>
</template>
    
<script>
import moment from "moment"
import Vue from 'vue'
const COLOR = {
  GREEN: '#4caf50',
  RED: '#cc0000',
  GRAY: '#cccccc'
}
export default {
  props:{
    id: String,
    data: {type:Array, default:() => []},
  },
  components: {

  },
  data(){
    return {
      width: 840,
      height: 100,
      paddingXR: 10,
      paddingXL: 50,
      paddingY: 15,
      min: 0,
      max: 1,
      edgeLength: 50,
      ctx: undefined,
      points: [],
      target: undefined
    }
  },
  mounted() {
    // let max = 1
    // let min = 0
    let max = 3
    let min = -3
    this.data.forEach(d=>{
      if(d.score > max) {
        max = d.score
      }
      if(d.score < min) {
        min = d.score
      }
    })
    this.min = min
    this.max = max
    if(this.edgeLength * this.data.length > this.width) {
      this.edgeLength = this.width / this.data.length
    }
    this.initCancas()
  },
  methods: {
    calcX(index) {
      return index*this.edgeLength + this.paddingXL
    },
    calcY(v) {
      return (this.max-v)*this.height/(this.max-this.min) + this.paddingY
    },
    initCancas() {
      let canvas = document.getElementById(this.id); 
      canvas.width = this.width + this.paddingXL + this.paddingXR
      canvas.height = this.height + this.paddingY*2
      let ctx = canvas.getContext('2d');   
      this.ctx = ctx
      this.drawGuideLine()
      this.drawPoints()   
      // ctx.fillStyle="#000";                             
      // ctx.fillRect(0,0,this.width,this.height);       
      const self = this
      document.addEventListener('mousemove',function(event){
        const dom = document.getElementById(self.id)
        if(dom) {
          const rect = dom.getBoundingClientRect();
          const mouseX = event.clientX;
          const mouseY = event.clientY;
          if (mouseX >= rect.left && mouseX <= rect.right && mouseY >= rect.top && mouseY <= rect.bottom) {
            const x = mouseX - rect.left;
            const y = mouseY - rect.top;
            self.partPaint(x, y);
          }
          else {
            this.target = undefined
          }
        }
      })              
    },
    drawGuideLine() {
      const self = this
      function drawL(v, color) {
        const _y = self.calcY(v)
        self.ctx.beginPath();
        self.ctx.strokeStyle = color
        self.ctx.moveTo(0, _y);
        self.ctx.lineTo(self.width+self.paddingXL+self.paddingXR, _y);
        self.ctx.setLineDash([1, 2]);
        self.ctx.stroke();
        self.ctx.closePath();

        self.ctx.rect(0, _y-7, 25, 13);
        self.ctx.fillStyle = color;
        self.ctx.fill();
        self.ctx.fillStyle = '#fff';
        self.ctx.font = `8px Arial`;
        self.ctx.textAlign = 'center';
        self.ctx.textBaseline = 'middle';
        // 绘制文字
        self.ctx.fillText(`${v}分`, 12, _y);
      }
      drawL(1, COLOR.GREEN)
      drawL(0, COLOR.RED)
    },
    drawP(p, color, pointOnly) {
      const self = this
      const pathM = new Path2D();
      const path = new Path2D();

      self.ctx.setLineDash([0, 0]);

      self.ctx.beginPath();
      self.ctx.fillStyle = color?color:p.color 
      self.ctx.arc( p.x, p.y, 3.5, 0, 3.5*Math.PI );
      path.arc( p.x, p.y, 3.5, 0, 3.5*Math.PI );
      pathM.arc( p.x, p.y, 10, 0, 10*Math.PI );
      self.ctx.fill();
      if(!pointOnly) {
        self.ctx.font="11px Arial";
        self.ctx.textAlign = 'center';
        self.ctx.textBaseline = 'middle';
        const _s = `${p.p.score%1===0?p.p.score:p.p.score.toFixed(1)}`
        self.ctx.fillStyle = '#666'
        self.ctx.fillText(_s, p.x, p.y+12);
      }
      pathM.closePath();
      path.closePath();
      self.ctx.closePath();
      return {path, pathM}
    },
    drawPoints() {
      const self = this
      function drawL(p1, p2, color) {
        self.ctx.setLineDash([0, 0]);
        
        self.ctx.beginPath();
        self.ctx.strokeStyle = color
        self.ctx.moveTo(p1.x, p1.y);
        self.ctx.lineTo(p2.x, p2.y);
        self.ctx.stroke();
        self.ctx.closePath();
      }
      const data = [...this.data].sort((a, b)=>{return a.dt < b.dt})
      const points = []
      data.forEach((p, pi)=>{
        const _x = self.calcX(pi)
        const _y = self.calcY(p.score)
        const _c = p.score >= 1?COLOR.GREEN:p.score>=0?COLOR.GRAY:COLOR.RED

        points.push({x:_x, y:_y, color:_c, p:p,})
      })
      points.forEach((p, pi)=>{
        if(pi>0 && points.length > 1) {
          drawL(points[pi-1], p, p.color)
        }
      })
      points.forEach((p, pi)=>{
        const {path, pathM} = this.drawP(p)
        p.path = path
        p.pathM = pathM
      })
      this.points = points
    },
    partPaint(x, y) {
      const target = this.points.find((p) => {
        return this.ctx.isPointInPath(p.pathM, x, y);
      });
      if(this.target) {
        this.ctx.save();
        this.ctx.clip(this.target.path);
        this.ctx.clearRect(0, 0, this.width + this.paddingXL+this.paddingXR, this.height + this.paddingY*2);
        this.drawP(this.target, undefined, true)
        this.ctx.restore();
      }
      const dom = document.getElementById(this.id)
      if(target) {
        this.ctx.save();
        this.ctx.clip(target.path);
        this.ctx.clearRect(0, 0, this.width + this.paddingXL+this.paddingXR, this.height + this.paddingY*2);
        this.drawP(target, '#ff9800', true)
        this.target = target
        this.ctx.restore();
        if(dom) {
          dom.style.cursor = "pointer";
        }
      }
      else {
        if(dom) {
          dom.style.cursor = "default";
        }
        this.target = undefined
      }
    }
  }
}
</script>
<style lang="less">
.canvas-container {
  position: relative;
  .canvas-box {
    z-index: 1;
  }
  .canvas-tooltip { 
    cursor: pointer;
    z-index: 2;
    position: absolute;
    text-align: left;
    background: rgba(255, 255, 255, 0.8);
    padding: 10px;
    font-size: 12px;
    box-shadow: 2px 5px 5px rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    ul {
      margin: 0;
    }
    label {
      font-weight: bold;
      width: 90px;
      display: inline-block;
    }
  }
}
</style>